<template>
<div class="chapter">
<div class="inner_page">
<div id="Maps">
<p class="map-title">Maps</p>
<p class="map-para"><span href="#/xhtml/15_Chapter03#map_3" title="Link target outside of Sample">(Map) Route of U-6 15 through the Caribbean</span></p>
<p class="map-para"><span href="#/xhtml/18_Chapter06#map_4" title="Link target outside of Sample">(Map) U-Boat Losses in the South Atlantic</span></p>
<p class="map-para"><span href="#/xhtml/18_Chapter06#map_5" title="Link target outside of Sample">(Map) U-Boat Losses in the Indian Ocean</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 07_Maps.vue?03d8e496